import React, { FC, useRef, useEffect, useState } from "react";
import Section from "../../components/section";
import { PageHero } from "../../components/page-hero";
import Layout from "../../components/layout/layout";
import keyword_1 from "../../images/monitoringScreens/keyword_1.jpg";
import keyword_2 from "../../images/monitoringScreens/keyword_2.jpg";
import keyword_3 from "../../images/monitoringScreens/keyword_3.jpg";
import keyword_4 from "../../images/monitoringScreens/keyword_4.jpg";
import keyword_5 from "../../images/monitoringScreens/keyword_5.jpg";

import useCalculateHeightHook from "../../hooks/useCalculateHeightHook";
import "./styles.scss";

const KeywordMonitoring: FC = () => {
  const [size, videoLength] = useCalculateHeightHook();

  return (
    <div className="content-wrapper">
      <PageHero
        title="Keyword monitoring"
        subtitle="Monitor web pages for the presence or absence of specific keywords."
      />
      <Layout>
        <Section>
          <div className="col-lg-12 keyword-monitoring">
            <div className="go-back">
              <a className="learn_btn_two" href="/how-to-use-hexowatch">
                <svg
                  width="40px"
                  height="20px"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="long-arrow-alt-left"
                  className="svg-inline--fa fa-long-arrow-alt-left fa-w-14 icon"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
                  ></path>
                </svg>
                Back to how to use Hexowatch
              </a>
            </div>

            {size ? (
              <video
                controls
                poster={keyword_1}
                preload="none"
                ref={videoLength}
                style={{ height: size ? size : "auto" }}
              >
                <source
                  src={
                    "https://storage.googleapis.com/website.hexometer.com/Keyword_monitor_-_Walkthrough_1598173861.mp4"
                  }
                  type="video/mp4"
                />
              </video>
            ) : (
              <video
                controls
                poster={keyword_1}
                preload="none"
                ref={videoLength}
                style={{ visibility: "hidden" }}
              >
                <source
                  src={
                    "https://storage.googleapis.com/website.hexometer.com/Keyword_monitor_-_Walkthrough_1598173861.mp4"
                  }
                  type="video/mp4"
                />
              </video>
            )}

            <h2>Keyword monitor - Walkthrough</h2>
            <br />
            <div className="img-block">
              <img src={keyword_1} alt="Select keyword monitoring tool" />
            </div>
            <p className="mb">
              The keyword monitor is great for keeping an eye out for specific
              keywords on a page. This is ideal for picking up mentions of your
              brand, checking for special offers, or picking up on specific
              errors on a page.
            </p>

            <div className="img-block">
              <img src={keyword_2} alt="Preview desired URL" />
            </div>
            <p className="mb">
              To get started enter the URL you want to check and click preview.
            </p>

            <div className="img-block">
              <img
                src={keyword_3}
                alt="Choose to monitor for the presence of one or more keywords"
              />
            </div>
            <p className="mb">
              Once the page has loaded, you can choose to monitor for the
              presence of one or more keywords. Use the vertical pipe character
              to check for the presence of a keyword, and the presence of
              another. Alternatively use a comma to check for the presence of
              any number of different keywords.
            </p>

            <div className="img-block">
              <img
                src={keyword_4}
                alt="You can choose the frequency of the checks"
              />
            </div>
            <p className="mb">
              Next, you can choose the frequency of the checks, your preferred
              notification channels, as well as set custom start and end dates.
            </p>

            <div className="img-block">
              <img
                src={keyword_5}
                alt="click start monitoring to get started"
              />
            </div>
            <p className="mb">
              Then click start monitoring to get started. Hexowatch will keep an
              eye on the page and will notify you when the keywords are
              detected.
            </p>
          </div>
        </Section>
      </Layout>
    </div>
  );
};

export default KeywordMonitoring;
